import {
  AfterViewInit,
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from "@angular/forms";

import { LanguageService } from '@catch/services';
import { WidgetInstance } from 'friendly-challenge';

/**
 * Captcha control with usage of {@link https://friendlycaptcha.com}
 */
@Component({
  standalone: true,
  selector: 'ct-lib-friendly-captcha',
  templateUrl: './friendly-captcha.component.html',
  styleUrls: ['./friendly-captcha.component.scss'],
  imports: [],
})
export class FriendlyCaptchaComponent implements OnInit, AfterViewInit {
  private languageService = inject(LanguageService);

  @Input() control: UntypedFormControl;
  @Input() startMode: 'auto' | 'focus' | 'none' = 'none';
  @ViewChild('widget') widgetEl: ElementRef;
  public widget: WidgetInstance;
  private hasBeenStarted = false;

  constructor() {
    this.control = new UntypedFormControl(null, []);
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.languageService.languageChange$.subscribe({
      next: () => {
        this.setWidget();
      },
    });

    this.control.valueChanges.subscribe({
      next: (value) => {
        if (!value) {
          this.startMode = 'none';
          this.widget.init();
        }
      },
    });
  }

  start() {
    if (this.hasBeenStarted) return;
    this.widget.start();
  }

  setWidget() {
    this.widget = new WidgetInstance(this.widgetEl.nativeElement, {
      sitekey: 'FCMPE7D6EMG2VN5J',
      language: (
        this.languageService.currentLanguage.value ?? 'de-DE'
      ).substring(0, 2) as any,
      startMode: this.startMode,
      doneCallback: (solution) => {
        this.control.patchValue(solution);
      },
      startedCallback: () => {
        this.hasBeenStarted = true;
      },
    });
    this.control.patchValue(null);
  }
}
